/** Microsoft API scopes follow the configured public application, never a customer-specific literal. */
export function nativeApiScopes(clientId: string): string[] {
    if (!clientId) return [];
    if (!/^[A-Za-z0-9_-]{1,128}$/.test(clientId)) throw new Error('Invalid configured Microsoft application');
    return [`api://${clientId}/User.Read`];
}
